import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-3xl border transition-colors focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground',
        accent: 'border-transparent bg-accent font-semibold text-accent-foreground',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        warning: 'border-transparent bg-warning text-warning-foreground',
        success: 'border-transparent bg-success text-success-foreground',
        outline: 'text-foreground',
      },
      size: {
        default: 'px-2.5 py-1 text-xs',
        sm: 'px-2 py-[1px] text-xs',
        md: 'px-3.5 py-[7px] text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {
  nodeType?: 'span' | 'div';
}

function Badge({ className, variant, size, nodeType = 'div', ...props }: BadgeProps) {
  const Component = nodeType;
  return <Component className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

export { Badge, badgeVariants };
